
/**
 * JS has problems with modulo calculating if confronted with the negative values, e.g.
 * -1 % 3 = -1 (WRONG)
 * 7 % 4 = 3 (CORRECT)
 * The following function solves this problem
 * @param num Number to take the modulo of
 * @param modulo Modulo value
 * @returns {number}
 */
export function betterMod(num: number, modulo: number) {
  return ((num % modulo) + modulo) % modulo
}
